const asRoleType = <
  T extends { [K in keyof T]: { name: K; description: string } }
>(
  t: T
) => t;

export const Roles = asRoleType({
  usuario_sincronizar: {
    name: 'usuario_sincronizar',
    description: 'Permite sincronizar usuários'
  },
  usuario_write: {
    name: 'usuario_write',
    description: 'Permite visualizar, cadastrar, editar usuários'
  },
  usuario_read: {
    name: 'usuario_read',
    description: 'Permite listar usuários'
  },
  usuario_view: {
    name: 'usuario_view',
    description: 'Permite visualizar usuários'
  },
  usuario_externo_write: {
    name: 'usuario_externo_write',
    description: 'Permite visualizar, cadastrar, editar Usuários Externos'
  },
  usuario_externo_read: {
    name: 'usuario_externo_read',
    description: 'Permite listar Usuários Externos'
  },
  usuario_externo_view: {
    name: 'usuario_externo_view',
    description: 'Permite visualizar Usuários Externos'
  },
  usuario_password: {
    name: 'usuario_password',
    description: 'Permite alterar a senha do usuário'
  },
  usuario_copy_roles: {
    name: 'usuario_copy_roles',
    description: 'Permite copiar as permissões'
  },
  permissao_write: {
    name: 'permissao_write',
    description: 'Permite vincular permissões aos usuários'
  },
  grupo_permissao_read: {
    name: 'grupo_permissao_read',
    description: 'Permite listar os grupos de permissões'
  },
  grupo_permissao_write: {
    name: 'grupo_permissao_write',
    description: 'Permite visualizar, cadastrar, editar grupos de permissões'
  },
  grupo_permissao_vinculo_write: {
    name: 'grupo_permissao_vinculo_write',
    description: 'Permite vincular grupos de permissões'
  },
  grupo_permissao_copy: {
    name: 'grupo_permissao_copy',
    description: 'Permite copiar os grupos de permissões'
  },
  usuario_view_event: {
    name: 'usuario_view_event',
    description:
      'Permite ver os logs de interação do usuário com o sistema (login logout)'
  },
  permissao_entity_write: {
    name: 'permissao_entity_write',
    description: 'Permite vincular entidades ao usuário'
  },
  admin_backup: {
    name: 'admin_backup',
    description: 'Administrar Backups'
  },
  admin_backup_download: {
    name: 'admin_backup_download',
    description: 'Baixar Backups'
  },
  politicas_seguranca: {
    name: 'politicas_seguranca',
    description: 'Políticas de Segurança'
  },
  politicas_seguranca_manage: {
    name: 'politicas_seguranca_manage',
    description: 'Gerenciar Políticas de Segurança'
  },
  sector_config_write: {
    name: 'sector_config_write',
    description:
      'Permite visualizar, cadastrar, editar configurações de setores'
  },
  sector_config_read: {
    name: 'sector_config_read',
    description: 'Permite listar configurações de setores'
  },
  sector_read: {
    name: 'sector_read',
    description: 'Permite listar setores'
  },
  sector_write: {
    name: 'sector_write',
    description: 'Permite editar setores'
  },
  user_sector_write: {
    name: 'user_sector_write',
    description: 'Permite editar setores do usuário'
  },
  dynamic_form_write: {
    name: 'dynamic_form_write',
    description: 'Permite visualizar, cadastrar, editar formulários dinâmicos'
  },
  dynamic_form_read: {
    name: 'dynamic_form_read',
    description: 'Permite listar formulários dinâmicos'
  },
  sector_role_read: {
    name: 'sector_role_read',
    description: 'Permite listar funções de setores'
  },
  sector_role_write: {
    name: 'sector_role_write',
    description: 'Permite visualizar, cadastrar, editar funções de setores'
  },
  remetente_read: {
    name: 'remetente_read',
    description: 'Permite visualizar remetentes'
  },
  remetente_write: {
    name: 'remetente_write',
    description: 'Permite cadastrar e editar remetentes'
  },
  tipo_verificacao_write: {
    name: 'tipo_verificacao_write',
    description: 'Permite visualizar, ativar e desativar tipos de verificação'
  },
  configuracao_read: {
    name: 'configuracao_read',
    description: 'Permite visualizar a tela de configurações'
  },
  configuracao_write: {
    name: 'configuracao_write',
    description: 'Permite editar os valores na tela de configurações'
  },
  central_comunicacao_read: {
    name: 'central_comunicacao_read',
    description: 'Permite visualizar a tela de central de comunicação'
  },
  central_comunicacao_write: {
    name: 'central_comunicacao_write',
    description: 'Permite cadastrar centrais de comunicações'
  },
  verificacao_documentos_read: {
    name: 'verificacao_documentos_read',
    description: 'Permite visualizar a tela de verificação de documentos'
  },
  verificacao_documentos_write: {
    name: 'verificacao_documentos_write',
    description: 'Permite editar os valores de verificação de documentos'
  },
  log_revisoes_view: {
    name: 'log_revisoes_view',
    description: 'Permite visualizar a tela de Log Revisões'
  }
});
